import React, { useEffect, useState } from 'react';
import { Formik, Field, Form } from 'formik';
import { Button, Card, CardBody, FormGroup, Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import InputMask from 'react-input-mask';
import { Input, Label } from 'reactstrap';
import FormikInputField from 'components/common/Fields/FormikInputField';
import FormikCheckboxField from 'components/common/Fields/FormikCheckboxField';
import useAxios from 'hooks/useAxios';
import { dateFormate } from 'utils/columns';

const FaxForwardToCE = (props) => {
    const API = useAxios();

    const {
        faxID,
        coveredEntityID,
        patientFirstName,
        patientLastName,
        patientDOB,
        providerNPI,
        providerFirstName,
        providerLastName,
        authFaxNumber,
        forwardCEComments,
    } = props.fax;
    const { onClose, refresh,tenantID } = props;
    // const { tenantID } = useParams();
    const [faxInputNumber, setFaxInputNumber] = useState(authFaxNumber);
    const [ceComments, setCEComments] = useState(forwardCEComments);
    const [ceCommentsError, setCECommentsError] = useState(false);
    const [faxError, setFaxError] = useState(false);


    useEffect(() => {
        setFaxInputNumber(authFaxNumber);
        setCEComments(forwardCEComments);
    }, []);

    const initialValues = {
        updateFaxNumber: false,
        comments: '',
    };

    const handleSubmit = async (values, { setSubmitting, setErrors }) => {
        const convertFaxNumber = (faxInputNumber != null && faxInputNumber.length > 0) ? faxInputNumber.replace(/\D/g, '') : "";
        if (convertFaxNumber.length < 10) return setFaxError(true);

        if (ceComments === null || ceComments === undefined || ceComments.length == 0) return setCECommentsError(true);

        const payload = {};
        payload.faxDetailID = faxID;
        payload.coveredEntityID = coveredEntityID;
        payload.authFaxNumber = convertFaxNumber;
        payload.forwardCEComments = ceComments;
        payload.updateFaxNumber = values.updateFaxNumber;

        try {

            if (values.updateFaxNumber) {
                const payLoad1 = {};
                payLoad1.ConverEntityID = coveredEntityID;
                payLoad1.AuthFaxNumber = convertFaxNumber;
                await API.post(`Config/ceconfig/updatecefaxnumber`, payLoad1);
            }

            await API.post(`/${tenantID}/fax/forwardFax`, payload);
            toast.success('Fax forward updated successfully!');
            refresh();
            setSubmitting(false);
            onClose();
        } catch (error) {
            setSubmitting(false);
            toast.error('An error occurred');
        }
    };

    return (
        <Card className='border-0 rounded shadow-top'>
            <CardBody>
                <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    children={({ values, isSubmitting, isValid }) => {
                        return (
                            <Form>
                                <Row className='mb-2'>
                                    <Col sm='4'>
                                        <p className='f-14 mb-0'>
                                            Patient First Name:
                                            <b className='d-block font-weight-500'>
                                                {patientFirstName}
                                            </b>
                                        </p>
                                    </Col>
                                    <Col sm='4'>
                                        <p className='f-14 mb-0'>
                                            Patient Last Name:
                                            <b className='d-block font-weight-500'>
                                                {patientLastName}
                                            </b>
                                        </p>
                                    </Col>
                                    <Col sm='4'>
                                        <p className='f-14 mb-0'>
                                            Patient DOB:
                                            <b className='d-block font-weight-500'>
                                                {dateFormate(patientDOB)}
                                            </b>
                                        </p>
                                    </Col>
                                </Row>
                                <Row className='mb-2'>
                                    <Col sm='4'>
                                        <p className='f-14 mb-0'>
                                            Provider NPI:
                                            <b className='d-block font-weight-500'>
                                                {providerNPI}
                                            </b>
                                        </p>
                                    </Col>
                                    <Col sm='4'>
                                        <p className='f-14 mb-0'>
                                            Provider First Name:
                                            <b className='d-block font-weight-500'>
                                                {providerFirstName}
                                            </b>
                                        </p>
                                    </Col>
                                    <Col sm='4'>
                                        <p className='f-14 mb-0'>
                                            Provider Last Name:
                                            <b className='d-block font-weight-500'>
                                                {providerLastName}
                                            </b>
                                        </p>
                                    </Col>

                                </Row>
                                <hr />
                                <Row>
                                    <Col sm='4'>
                                        <FormGroup>
                                            <Label className='label-color'>Fax Number</Label>
                                            <InputMask
                                                name='faxNumber'
                                                mask='(999)999-9999'
                                                value={faxInputNumber}
                                                onChange={(e) => {
                                                    const value = e.target.value || '';
                                                    console.log(value);
                                                    setFaxError(false);
                                                    setFaxInputNumber(value);
                                                }}
                                            >
                                                {(inputProps) => <Input {...inputProps} />}
                                            </InputMask>
                                            {faxError && (
                                                <div className='text-danger font-size-12'>
                                                    Enter valid number
                                                </div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col sm='12'>
                                        <FormGroup>
                                            <Field
                                                key='updateFaxNumber'
                                                id='updateFaxNumber'
                                                name='updateFaxNumber'
                                                type='checkbox'
                                                component={FormikCheckboxField}
                                                label='Update Fax Number'
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col sm='12'>
                                        <FormGroup>
                                            <Label className='label-color'>Comments</Label>
                                            <Input
                                                key='comments'
                                                id='comments'
                                                name='comments'
                                                type='textarea'
                                                label='Comment'
                                                value={ceComments}
                                                onChange={(e) => {
                                                    setCEComments(e.target.value);
                                                    setCECommentsError(false);
                                                }}
                                                component={FormikInputField}
                                            />
                                            {ceCommentsError && (
                                                <div className='text-danger font-size-12'>
                                                    Comments required.
                                                </div>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <div className='d-flex justify-content-end align-items-center'>
                                    <div>
                                        <Button
                                            color='primary'
                                            type='submit'
                                            size='sm'
                                            className='search'
                                            disabled={!isValid || isSubmitting}
                                        >
                                            Forward To CE
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                ></Formik>
            </CardBody>
        </Card>
    );
};

export default FaxForwardToCE;